import React from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    IconButton,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import styled from "styled-components";
import { Save } from "@mui/icons-material";
import request from "src/utils/request";

const SectionTitle = styled.h2`
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    padding: 0;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const CardContainer = styled(Paper)`
    border-radius: 14px;
    border: ${({ theme, result }) => {
        if (result === "pending") return `2px solid ${theme.palette.text.disabled}`;
        if (result === "success") return `2px solid ${theme.palette.success.main}`;
        if (result === "failure") return `2px solid ${theme.palette.error.main}`;
        return `2px solid transparent`;
    }};
`;

const SubText = styled(Typography)`
    font-size: 12px;
    color: ${({ theme }) => theme.palette.text.disabled};
`;

const SectionTitleIcon = styled(Stack)`
    height: 22px;
    width: 22px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-radius: 2px;
`;

const LeaderboardSettingsCard = ({ user, updateUser }) => {
    if (!user) return null;
    const [isProfilePublic, setIsProfilePublic] = React.useState(
        (user && user.profileVisibility) || "private"
    );
    const [isRankingOnProfile, setIsRankingOnProfile] = React.useState(
        (user && user.rankVisibility) || "private"
    );
    const [changes, setChanges] = React.useState("");
    const [saveResult, setSaveResult] = React.useState();

    const handleSetProfile = () => {
        if (isProfilePublic === "private") setIsProfilePublic("public");
        else setIsProfilePublic("private");
        setChanges({ enabled: !isProfilePublic });
    };

    const setRankingOnProfile = () => {
        if (isRankingOnProfile === "private") setIsRankingOnProfile("public");
        else setIsRankingOnProfile("private");
        setChanges({ enabled: !isRankingOnProfile });
    };
    const hasChanges = () => !!Object.keys(changes).find(() => !!changes);

    React.useEffect(() => {
        setTimeout(() => {
            if (saveResult === "success" || saveResult === "failure") setSaveResult(undefined);
        }, 500);
    }, [saveResult]);

    const saveHandler = async () => {
        setSaveResult("pending");
        try {
            await request("/api/users/me", {
                method: "POST",
                body: JSON.stringify({
                    profileVisibility: isProfilePublic,
                    rankVisibility: isRankingOnProfile,
                }),
            });
            await updateUser();
            setChanges("");
            setSaveResult("success");
        } catch (e) {
            setSaveResult("failure");
        }
    };

    return (
        <>
            <Stack direction="row" justifyContent="space-between" pl={2} pr={2} pt={2} pb={1}>
                <SectionTitle>Leaderboard & Sharing</SectionTitle>
                {hasChanges() && (
                    <SectionTitleIcon direction="row" justifyContent="center" alignItems="center">
                        <IconButton onClick={saveHandler}>
                            <Save color="secondary" fontSize="small" />
                        </IconButton>
                    </SectionTitleIcon>
                )}
            </Stack>
            <CardContainer result={saveResult}>
                <Box p={4}>
                    <Stack direction="column" mb={2} style={{ height: "100%" }}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isProfilePublic === "public"}
                                        onChange={handleSetProfile}
                                    />
                                }
                                label="Enable public profile"
                            />
                            <SubText>
                                By enabling this you will be able to share your public profile with
                                other users.
                            </SubText>
                        </FormGroup>
                    </Stack>
                    <Stack direction="column" mb={2} style={{ height: "100%" }}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isRankingOnProfile === "public"}
                                        onChange={setRankingOnProfile}
                                    />
                                }
                                label="Show Adadot ranking on profile"
                            />
                            <SubText>
                                Enable or disable the visibility of adadot ranking on your public
                                profile
                            </SubText>
                        </FormGroup>
                    </Stack>
                </Box>
            </CardContainer>
        </>
    );
};

export default LeaderboardSettingsCard;
